/**
 * The iOS app's native bridge (ios/readlang/Bridge.js), the web app's only way
 * to reach it (ESLint keeps `window.READLANG.iOSApp` to this module).
 *
 * The app takes its web app from the server, so every app version still in
 * use runs the latest web app against the bridge it was built with. So:
 *
 * - Bridge methods and actions are only added, never renamed, removed or
 *   given another meaning. Arguments and results may gain optional fields.
 * - A new method is optional in window.d.ts until every supported app version
 *   has it, and callers check for it: `iOSBridge.get()?.newMethod?.()`.
 * - The same goes, the other way, for what the app calls on the page
 *   (`window.READLANG.nativeHeader.perform`…; the end of window.d.ts's
 *   READLANG).
 * - A change older versions can't follow raises the minimum version
 *   (shared/iOSApp.js), which sends them the update page instead. Where a
 *   method's behaviour differs between versions, check the version:
 *   `iOSApp.versionFromUserAgent(navigator.userAgent)`.
 */

export type Bridge = NonNullable<Window["READLANG"]["iOSApp"]>;

/** The bridge, in the iOS app only */
export const get = (): Bridge | undefined => window.READLANG?.iOSApp;
